import { forwardRef, useState } from "react";
import EyeSlashIcon from "../Assets/Icons/outline/eye-slash.svg";
import EyeIcon from "../Assets/Icons/outline/eye.svg";

const Input = forwardRef(function Input(
	{ icon, type, id, placeholder, required, errors, numberOnly, disabled, ...props },
	ref
) {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className="mb-3 text-start">
			<div className="relative">
				{icon && (
					<div className="absolute inset-y-0 start-0 flex items-center ps-2.5 pointer-events-none">
						<img src={icon} alt="" />
					</div>
				)}
				<input
					type={showPassword ? "text" : type}
					id={id}
					disabled={disabled}
					className={`border border-black text-gray-900 rounded-xl focus:ring-black focus:border-black block w-full ${
						icon ? "ps-10" : ""
					} ${showPassword ? "pe-10" : ""} p-3`}
					placeholder={placeholder}
					required={required ?? false}
					ref={ref}
					{...props}
				/>
				{type === "password" && (
					<div
						className="absolute z-40 inset-y-0 end-5 flex items-center ps-2.5"
						role="button"
						onClick={() => setShowPassword((prev) => (prev ? false : true))}
					>
						<img src={showPassword ? EyeSlashIcon : EyeIcon} alt="" />
					</div>
				)}
			</div>

			{errors && <small className={`text-[red] ${icon && "ps-10"}`}>{errors}</small>}
		</div>
	);
});

export default Input;
